import { ChevronDown, Menu, User, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";

function ResumeReviewsHeader() {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	return (
		<header id="my-resumes" className="sticky top-0 z-50 bg-white shadow-sm">
			<nav className="container flex items-center justify-between py-3">
				<div className="flex items-center gap-3">
					<button
						type="button"
						className="lg:hidden"
						onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
						aria-label="Toggle navigation"
					>
						{mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
					</button>
					<Link to="/">
						<img className="h-8 w-auto" src="/images/logo.png" alt="Logo" />
					</Link>
				</div>

				<div className="flex items-center gap-4">
					<ul className="flex items-center gap-3 text-xl">
						<li>
							<Link to="#" className="text-blue-700">
								<span className="fa fa-comments" />
							</Link>
						</li>
						<li>
							<Link className="text-blue-700" to="#">
								<span className="fa fa-bell" />
							</Link>
						</li>
					</ul>

					<DropdownMenu>
						<DropdownMenuTrigger className="flex items-center gap-1 text-sm font-bold text-gray-900 outline-none">
							<User className="h-5 w-5 text-blue-700" />
							Hi, Jacquiline
							<ChevronDown className="h-4 w-4" />
						</DropdownMenuTrigger>
						<DropdownMenuContent align="end" className="w-48">
							<DropdownMenuItem asChild>
								<Link to="/settings">My Settings</Link>
							</DropdownMenuItem>
							<DropdownMenuItem asChild>
								<Link to="/signin">Log Out</Link>
							</DropdownMenuItem>
						</DropdownMenuContent>
					</DropdownMenu>
				</div>
			</nav>
		</header>
	);
}

export default ResumeReviewsHeader;
